
















import * as CurrentTime from '@/models/current-time/functions'

import _ from 'lodash'
import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'

import DropdownSelect from '../../atoms/DropdownSelect.vue'
import { SelectItem } from '../../atoms/model/SelectItem'

@Component({
  components: {
    DropdownSelect,
  },
})
export default class YearDropdownSelect extends Vue {
  @Prop({ default: 150 })
  limit: number

  /**
   * disabled項目が（初期表示時に）選択されている可能性をnullとして表現している。
   */
  @Prop({ default: null })
  value: number | null

  @Prop({
    // default: 全ての要素を有効とする
    default: () => (() => false),
  })
  disableFilter: (year: number) => boolean

  get yearList(): SelectItem[] {
    const currentYear = CurrentTime.create().now.getFullYear()
    const yearRange: number[] = _.range(currentYear, currentYear - this.limit)

    return [
      {
        text: '',
        value: '',
        selected: this.value === null,
        disabled: true,
      },
      ...yearRange.map((year: number) => ({
        value: `${year}`,
        text: `${year}`,
        selected: year === this.value,
        disabled: this.disableFilter ? this.disableFilter(year) : false,
      })),
    ]
  }

  onInput(value) {
    this.$emit('input', value)
  }
}
